import "./Properties.css";
import PropertyListing from "./PropertyListing/PropertyListing";
import InventoryListing from "./InventoryListing/InventoryListing";
import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";

// import { ref } from "firebase/storage";

// import {
//   TabComponent,
//   TabItemDirective,
//   TabItemsDirective,
// } from "@syncfusion/ej2-react-navigations";

import Filters from "./Filters/Filters";
import SharedListing from "./sharedListing/SharedListing";
import { MobileScreenFilter } from "./Filters/MobileScreenFilter";
import FabButton from "../../components/FabButton/FabButton";
import { useEffect } from "react";

export const refreshContext = createContext();
export const resultsContext = createContext();

const Properties = () => {
  const navigate = useNavigate();
  const [Type, setType] = useState("*");
  const [toggleFilters, setToggleFilters] = useState(false);

  const [result, setResult] = useState(0);

  const [refresh, setRefresh] = useState(false);
  const refreshData = () => {
    setRefresh(true);
    setTimeout(() => {
      setRefresh(false);
    }, 100);
  };

  // const TabInstance = ref(new TabComponent({}));
  const [SelectedTab, setSelectedTab] = useState(1);
  // const [Tabs, setTabs] = useState([
  //   { text: "Public", id: "Public" },
  //   { text: "Inventory", id: "Inventory" },
  //   { text: "Shared", id: "Shared" },
  // ]);

  // TabInstance.select("Inventory");

  const defaultFilters = {
    PriceRange: [0, 1000000000000000000],
    PropertySize: [0, 30],
    PropertyType: "*",
    PropertySubType: "*",
    Purpose: "*",
    Confirmation: "*",
    LandUnit: "*",
    Bedrooms: "*",
    Bathrooms: "*",
    City: "*",
  };
  const [FiltersParams, setFiltersParams] = useState({ ...defaultFilters });
  const areFiltersSetToDefault = () =>
    JSON.stringify({ ...FiltersParams }) ===
    JSON.stringify({ ...defaultFilters });

  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const setWindowDimensions = () => {
    if (window.innerWidth < 575) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  //  Mobile screen login ends

  return (
    <>
      {toggleFilters && (
        <MobileScreenFilter
          {...{
            toggleFilters,
            setToggleFilters,
            FiltersParams,
            setFiltersParams,
            defaultFilters,
          }}
        />
      )}

      <refreshContext.Provider value={refreshData}>
        <resultsContext.Provider value={setResult}>
          <div className="global-body-container property-fluid-container">
            <div className="property-filter-top-container">
              <div className="row filters-row">
                <div className="col-12 col-sm-12 col-md-12 col-xl-12">
                  <Filters
                    {...{
                      FiltersParams,
                      setFiltersParams,
                      defaultFilters,
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="property-header-banner">
              <div>
                <span className="total-properties d-sm-none d-xs-none  d-lg-block">
                  Available Properties : {result}
                </span>
                <span className="total-properties-mobile d-lg-none">
                  Properties
                  <span className="tot-no-of-properties">{`(${result})`}</span>
                </span>
              </div>
              <div
                className="d-flex 
                    align-items-center
                    "
              >
                <div className="p-tabs">
                  <div
                    className={`tab-item ${
                      SelectedTab === 0 ? "active-tab" : ""
                    }`}
                    onClick={() => {
                      setSelectedTab(0);
                    }}
                  >
                    Public
                  </div>
                  <div
                    className={`tab-item ${
                      SelectedTab === 1 ? "active-tab" : ""
                    }`}
                    onClick={() => {
                      setSelectedTab(1);
                    }}
                  >
                    Inventory
                  </div>
                  <div
                    className={`tab-item ${
                      SelectedTab === 2 ? "active-tab" : ""
                    }`}
                    onClick={() => {
                      setSelectedTab(2);
                    }}
                  >
                    Shared
                  </div>
                </div>
                {/* <TabComponent
                  className="tabs-container"
                  ref={(tab) => (TabInstance.current = tab)}
                  selected={({ selectedIndex }) =>
                    setSelectedTab(selectedIndex)
                  }
                  selectedItem={SelectedTab}
                >
                  <TabItemsDirective>
                    <TabItemDirective header={Tabs[0]} />
                    <TabItemDirective header={Tabs[1]} />
                    <TabItemDirective header={Tabs[2]} />
                  </TabItemsDirective>
                </TabComponent> */}
                <span
                  className="filters-toggle"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setToggleFilters(true);
                  }}
                >
                  <svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.28777 2H0.514286C0.230256 2 0 1.77614 0 1.5C0 1.22386 0.230256 1 0.514286 1H7.28777C7.49959 0.417407 8.07106 0 8.74286 0C9.41465 0 9.98613 0.417407 10.1979 1H11.4857C11.7697 1 12 1.22386 12 1.5C12 1.77614 11.7697 2 11.4857 2H10.1979C9.98613 2.58259 9.41465 3 8.74286 3C8.07106 3 7.49959 2.58259 7.28777 2Z"
                      fill="#4C3CA6"
                    />
                    <path
                      d="M11.4857 7C11.7697 7 12 6.77613 12 6.5C12 6.22387 11.7697 6 11.4857 6H4.71223C4.5004 5.4174 3.92891 5 3.25714 5C2.58538 5 2.01388 5.4174 1.80208 6H0.514286C0.230256 6 0 6.22387 0 6.5C0 6.77613 0.230256 7 0.514286 7H1.80208C2.01388 7.5826 2.58538 8 3.25714 8C3.92891 8 4.5004 7.5826 4.71223 7H11.4857Z"
                      fill="#4C3CA6"
                    />
                  </svg>
                </span>
              </div>
              <div className="property-refresh-container">
                <span
                  className="properties-refresh-button"
                  onClick={refreshData}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.2499 12C20.2499 7.44365 16.5563 3.75 11.9999 3.75V2.25C17.3847 2.25 21.7499 6.61522 21.7499 12C21.7499 17.3848 17.3847 21.75 11.9999 21.75C6.61513 21.75 2.2499 17.3848 2.2499 12C2.2499 9.20732 3.42436 6.68932 5.30447 4.9125H1.7749V3.4125H8.2749V9.9125H6.7749V5.61509C4.92723 7.12888 3.7499 9.42717 3.7499 12C3.7499 16.5563 7.44356 20.25 11.9999 20.25C16.5563 20.25 20.2499 16.5563 20.2499 12Z"
                      fill="#4C3CA6"
                    />
                  </svg>
                  <span className="property-refresh-text"></span>
                </span>
                <button
                  style={{
                    fontSize: 12,
                    paddingRight: "10px",
                  }}
                  className="form-submit-button py-1"
                  onClick={() => {
                    navigate("/user/properties/add");
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 17V7"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                    <path
                      d="M7 12H17"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>{" "}
                  Add Property
                </button>
              </div>
            </div>

            <div className="properties-container">
              {SelectedTab === 0 && !refresh && (
                <PropertyListing
                  {...{
                    Type,
                    FiltersParams,
                    areFiltersSetToDefault,
                  }}
                />
              )}

              {SelectedTab === 1 && !refresh && (
                <InventoryListing
                  {...{
                    Type,
                    FiltersParams,
                    areFiltersSetToDefault,
                  }}
                />
              )}

              {SelectedTab === 2 && !refresh && (
                <SharedListing
                  {...{
                    Type,
                    FiltersParams,
                    areFiltersSetToDefault,
                  }}
                />
              )}
              {isMobile && (
                <FabButton
                  onClick={() => {
                    navigate("/user/properties/add");
                  }}
                />
              )}

              {/* <div className="add-property-btn-mobile-container">
                    <button
                      onClick={() => {
                        navigate("/user/properties/add");
                      }}
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 11V1"
                          stroke="#4C3CA6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M1 6H11"
                          stroke="#4C3CA6"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                      </svg>
                    </button>
                  </div> */}
            </div>
          </div>
        </resultsContext.Provider>
      </refreshContext.Provider>
    </>
  );
};

export default Properties;
